import React from 'react'
import { ClipLoader } from 'react-spinners'

export const Loading = () => (
  <div className="w-100 h-100 d-flex justify-content-center align-items-center">
    <ClipLoader/>
  </div>
)